import { render } from "./QualityInspectInfo.vue?vue&type=template&id=55d3e9ce"
import script from "./QualityInspectInfo.vue?vue&type=script&lang=js"
export * from "./QualityInspectInfo.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/quality_inspect.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fagro_exporter%2Fquality_control%2Fcontainer%2FQualityInspectInfo.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/components/views/agro_exporter/quality_control/container/export_quality_inspect_info.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fagro_exporter%2Fquality_control%2Fcontainer%2FQualityInspectInfo.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__